// extracted by mini-css-extract-plugin
export default {"container":"footerTermItem_container__P3w3B","link":"footerTermItem_link__JhUib"};